import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from 'react-router-dom';
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import InfoAndPoliciesNav from './InfoAndPoliciesNav';
import HotelInfo from './HotelInfo';
import { useQuery } from "@apollo/client";
import { GET_ALL_HOTEL_INFOS } from "graphql/service";
import { HotelInfoAndPoliciesContainer, Content, Container } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";

const HotelInfoAndPolicies = () => {

  const [hotelInfos, setHotelInfos] = useState([]);

  const { data: hotelInfosData, error } = useQuery(GET_ALL_HOTEL_INFOS);

  useEffect(() => {
    if (hotelInfosData) {
      setHotelInfos(hotelInfosData.hotelInfos);
    }
  }, [hotelInfosData]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  return (
    <HotelInfoAndPoliciesContainer>
      <InfoAndPoliciesNav />
      <Content>
        <Routes>
          <Route
            path={'/'}
            element={<>Settings Dashboard</>}
          />
          <Route
            path={'hotel-info'}
            element={<HotelInfo />}
          />
          <Route path="*" element={<Navigate to="/settings/hotel-info-and-policies/hotel-info" replace />} />
        </Routes>
      </Content>
    </HotelInfoAndPoliciesContainer>
  );
};

export default HotelInfoAndPolicies;
